// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1l1A3","log":"ModalInventoryLogs_log__3T6hD","date":"ModalInventoryLogs_date__3gre6","userName":"ModalInventoryLogs_userName__2Yw3m"};